// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** @format */

.custom-day {
	text-align: center;
	padding: 0.185rem 0.25rem;
	display: inline-block;
	height: 2rem;
	width: 2rem;
}
.custom-day.focused {
	background-color: #e6e6e6;
}
.custom-day.range,
.custom-day:hover {
	background-color: rgb(2, 117, 216);
	color: white;
}
.custom-day.faded {
	background-color: rgba(2, 117, 216, 0.5);
}

.formLabelNote {
	color: #9f9f9f;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/search-form/search-form.component.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb;CACC,kBAAkB;CAClB,yBAAyB;CACzB,qBAAqB;CACrB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,yBAAyB;AAC1B;AACA;;CAEC,kCAAkC;CAClC,YAAY;AACb;AACA;CACC,wCAAwC;AACzC;;AAEA;CACC,cAAc;AACf","sourcesContent":["/** @format */\r\n\r\n.custom-day {\r\n\ttext-align: center;\r\n\tpadding: 0.185rem 0.25rem;\r\n\tdisplay: inline-block;\r\n\theight: 2rem;\r\n\twidth: 2rem;\r\n}\r\n.custom-day.focused {\r\n\tbackground-color: #e6e6e6;\r\n}\r\n.custom-day.range,\r\n.custom-day:hover {\r\n\tbackground-color: rgb(2, 117, 216);\r\n\tcolor: white;\r\n}\r\n.custom-day.faded {\r\n\tbackground-color: rgba(2, 117, 216, 0.5);\r\n}\r\n\r\n.formLabelNote {\r\n\tcolor: #9f9f9f;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
